import { useState, useEffect } from 'react'
import { api } from '../services'
import type { AlertMarker } from '../utils/chartHelpers'

export type { AlertMarker }

export function useAlertChartMarkers(deviceId: number | undefined, dateFrom?: string, dateTo?: string): AlertMarker[] {
  const [markers, setMarkers] = useState<AlertMarker[]>([])

  useEffect(() => {
    if (!deviceId) return

    api.getAlertChartMarkers(deviceId, dateFrom, dateTo)
      .then((response: any) => {
        if (response?.data) {
          setMarkers(response.data.map((m: any) => ({
            timestamp: new Date(m.created),
            alertType: m.alertType,
            severity: m.severity,
            isRecovery: m.isRecovery,
            title: m.title,
          })))
        }
      })
      .catch(() => {
        // Silently fail - markers are enhancement only
        setMarkers([])
      })
  }, [deviceId, dateFrom, dateTo])

  return markers
}
